import React from "react";
import { toast } from "react-toastify";
import Lottie from "react-lottie";
import animationData from "../jsons/Animation-building-1.json";

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error; // Store the error object for more detailed reporting or user messages.
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // You can also process the error here and return a modified state
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Log error to an error reporting service
    toast.error("Error caught in error boundary");
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    // Optionally log to an external service here
  }

  retry = () => {
    this.setState({ hasError: false, error: undefined });
  };

  defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    renderer: "svg",
  };

  render() {
    if (this.state.hasError) {
      // Customize the message based on the error state or type
      return (
        <div className="max-h-screen h-[400px]">
          <h1 className="flex items-center justify-center mt-8 mx-auto opacity-20">
            خطایی رخ داده است. لطفا مجددا صفحه را بارگذاری نمایید.
          </h1>
          <button
            onClick={this.retry}
            className="flex items-center justify-center mt-2 mx-auto"
          >
            Try again
          </button>
          <Lottie options={this.defaultOptions} />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
